import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import { Button, Menu, Drawer } from 'antd'

import Leave from './Leave'
import Attendance from './Attendance'
import SpecialRequest from './SpecialRequest'
import Meetings from './Meetings'
import Salary from './Salary'
import OfficeRequirements from './OfficeRequirements'
import Incentives from './Incentives'

const DesktopMenuContainer = styled.div`
  border-bottom: 1px solid #275058;
  // padding-bottom: 20px;
`

const StyledMenuItemDesktop = styled(Menu.Item)`
  //   width: 11%;
  //   text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #275058;
  padding-bottom: 10px;
  text-transform: uppercase;
  @media (max-width: 1400px) {
    // font-size: 18px;
    // width: 12%;
    // border: 1px solid red;
  }
`

function BottomNavContainer(props) {
  const { selectedTab, setSelectedTab, leadInfo } = props
  const navigate = useNavigate()
  const location = useLocation()

  const generateJsx = () => {
    // console.log(selectedTab)
    if (selectedTab === '1') {
      return <Attendance leadInfo={leadInfo} />
    } else if (selectedTab === '2') {
      return <Leave leadInfo={leadInfo} />
    } else if (selectedTab === '3') {
      return <Meetings leadInfo={leadInfo} />
    } else if (selectedTab === '4') {
      return <Salary leadInfo={leadInfo} />
    } else if (selectedTab === '5') {
      return <Incentives leadInfo={leadInfo} />
    } else if (selectedTab === '6') {
      return <SpecialRequest leadInfo={leadInfo} />
    } else if (selectedTab === '7') {
      return <OfficeRequirements leadInfo={leadInfo} />
    }
  }

  useEffect(() => {
    // to keep the current tab ready for hard refresh of page
    if (selectedTab)
      navigate(`/cm/${leadInfo._id}?tab=${selectedTab}`, {
        state: { ...location.state }, // if any state is passed, making sure here this is also available after auto navigation via useEffect hook, in future sub components. E.g. OverviewCard.js
      })
  }, [selectedTab])

  return (
    <div>
      <DesktopMenuContainer>
        {/* Nav element goes here */}
        <Menu
          mode="horizontal"
          defaultSelectedKeys={selectedTab}
          disabledOverflow={true}
          style={{
            marginLeft: `15%`,
            // marginRight: `15%`,
            marginTop: 20,
            paddingLeft: '2%',
            // borderBottom: '1px solid #275058',
            width: '90%', // to expand the menu in medium large screen ( to avoid overlapping )
          }}
        >
          <StyledMenuItemDesktop
            key="1"
            onClick={(v) => {
              setSelectedTab(v.key)
            }}
          >
            attendance
          </StyledMenuItemDesktop>
          <StyledMenuItemDesktop
            key="2"
            onClick={(v) => {
              setSelectedTab(v.key)
            }}
          >
            leave
          </StyledMenuItemDesktop>
          <StyledMenuItemDesktop
            key="3"
            onClick={(v) => {
              setSelectedTab(v.key)
            }}
          >
            meetings
          </StyledMenuItemDesktop>
          <StyledMenuItemDesktop
            key="4"
            onClick={(v) => {
              setSelectedTab(v.key)
            }}
          >
            salary
          </StyledMenuItemDesktop>
          <StyledMenuItemDesktop
            key="5"
            onClick={(v) => {
              setSelectedTab(v.key)
            }}
          >
            incentives
          </StyledMenuItemDesktop>
          <StyledMenuItemDesktop
            key="6"
            onClick={(v) => {
              setSelectedTab(v.key)
            }}
          >
            special request
          </StyledMenuItemDesktop>
          <StyledMenuItemDesktop
            key="7"
            onClick={(v) => {
              setSelectedTab(v.key)
            }}
          >
            office requirements
          </StyledMenuItemDesktop>
        </Menu>
        {/* <hr /> */}
      </DesktopMenuContainer>

      {generateJsx()}
    </div>
  )
}

export default BottomNavContainer
